// extracted by css-extract-rspack-plugin
export default {"alert-notice":"alert-notice-r48lx6","alertNotice":"alert-notice-r48lx6"};